const isProduction = process.env.NODE_ENV === 'production';

export const API_BASE_URL = isProduction
  ? 'https://vibraint.net'
  : 'http://localhost:5000';
